// common
export const getPagination = "/getPagination";
export const getById = "/getById";
export const getAllWithStatus = "/getAllWithStatus";
export const checkLogin = "/checkLogin";
export const forgotPassword = "/forgotPassword/";
export const fileHandling = "/fileHandling";
export const message = "/message";

//Role Master
export const roleMasterUrl = "/role";

//Course Master
export const courseMasterUrl = "/course";

//Followup Master
export const followupMasterUrl = "/followup";

//Payment Master
export const paymentMasterUrl = "/payment";

//Source Lead Master
export const sourceLeadMasterUrl = "/sourceLead";

//Expense Master
export const expenseMasterUrl = "/expense";

//Class Master
export const classMasterUrl = "/class";

//Branch Master
export const branchMasterUrl = "/branch";

//Batch Master
export const batchMasterUrl = "/batch";

//Staff Master
export const staffMasterUrl = "/staff";
export const loginMasterUrl = "/login";

//
export const privilegeMasterUrl = "/privilege";

// login
export const login = "/public/login";

//Lead Master
export const leadMasterUrl = "/lead";

//Lead Wise Followup
export const leadFollowupUrl = "/leadFollowup";

//Lead Transfer
export const leadTransferUrl = "/leadTransfer";

//Generate Expense Master
export const generateExpeseUrl = "/generateExpense";

// Admission Master
export const admissionMasterUrl = "/admission";

//Installment Master
export const installmentMasterUrl = "/installment";

// Expense Category Master
export const expenseCategoryUrl = "/expenseCategory";

// DashBoard
export const dashboardUrl = "/dashboard";

//Jasper
export const jasperUrl = "/jasper";

// Upload For Whatsapp Message
export const uploadForWhatsappMessageUrl = "/uploadForWhatsappMessage";

// From Whatsapp
export const sendFromAdmissionUrl = "/sendFromAdmission";
export const sendFromLeadUrl = "/sendFromLead";

// Gallery
export const galleryUrl = "/gallery";
export const deleteByIdUrl = "/deleteById/";
